import Categories from "../../../Components/Admin/Categories";

const CategoriesPage = () => {
  return <Categories />;
};

export default CategoriesPage;
